import * as zoid from 'zoid';

export const WidgetXcomponent = zoid.create({
  tag: 'widget-xcomponent',

  url: function (obj) { return obj.props.customUrl },

  props: {
    customUrl: {
      type: 'string',
      required: true,
    },
    cartToken: {
      type: 'string',
      required: false,
    },
    onSubmit: {
      type: 'function',
      required: false,
    },
    onTrigger: {
      type: 'function',
      required: false,
    },
    onInit: {
      type: 'function',
      required: false,
    },
    onSize: {
      type: 'function',
      required: false,
    },
    data: {
      type: 'object',
      required: false,
    },
  },

  contexts: {
    iframe: true,
    popup: false,
  },

  defaultContext: 'iframe',

  autoResize: {
    height: true,
    width: false,
    element: '.main-panel',
  },

  dimensions: {
    width: '100%',
    height: '100%',
  },

  defaultLogLevel: 'error',
});
